import { Box, LinearProgress, Typography, useTheme } from "@mui/material";
import { type FC, useMemo } from "react";

export const SaveProgressIndicator: FC<{ progress: number | null }> = ({ progress }) => {
  const theme = useTheme();

  const progressText = useMemo(() => {
    if (progress === null) return "";

    if (progress <= 25) {
      return "Preparing to save...";
    } else if (progress <= 50) {
      return "Optimizing...";
    } else if (progress <= 75) {
      return "Saving...";
    } else {
      return "Finalizing save";
    }
  }, [progress]);

  return (
    progress && (
      <Box
        sx={{
          p: 1,
          px: 2,
          bgcolor: "background.contrast",
          borderRadius: `${theme.shape.borderRadius}px`,
          width: 180,
        }}
      >
        <Typography lineHeight={2.2} variant="body2">
          {progressText}
        </Typography>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    )
  );
};
